<template>
  <el-form
    id="neo-form"
    ref="form"
    :model="form"
    label-position="top"
    @submit.prevent="submit"
  >
    <el-row type="flex" :gutter="20">
      <el-col :md="12">
        <el-form-item label="Name" prop="name" :rules="rules.name">
          <el-input v-model="form.name" placeholder="John Doe" />
        </el-form-item>
      </el-col>
      <el-col :md="12">
        <el-form-item label="Email" prop="email" :rules="rules.email">
          <el-input v-model="form.email" placeholder="john@doe.com" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row type="flex" :gutter="20">
      <el-col :md="12">
        <el-form-item
          label="Occupation"
          prop="occupation"
          :rules="rules.occupation"
        >
          <el-select
            v-model="form.occupation"
            filterable
            placeholder="Select occupation"
          >
            <el-option
              v-for="occupation in occupations"
              :key="occupation"
              :label="occupation"
              :value="occupation"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="12">
        <el-form-item label="Amount" prop="amount" :rules="rules.amount">
          <el-select
            v-model="form.amount"
            placeholder="Select amount you wish to send"
          >
            <el-option
              v-for="amount in amounts"
              :key="amount"
              :label="amount"
              :value="amount"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row type="flex">
      <el-col :md="24">
        <el-form-item label="Location" prop="location" :rules="rules.location">
          <el-select
            v-model="form.location"
            filterable
            placeholder="Select location"
          >
            <el-option
              v-for="location in locations"
              :key="location"
              :label="location"
              :value="location"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="isSuccess" type="flex">
      <el-col :span="24">
        <p class="success">Thank you for your interest. We'd be in touch!</p>
      </el-col>
    </el-row>
    <el-row justify="center">
      <el-col :md="9">
        <neo-button
          :size="'large'"
          :loading="submitting"
          :disabled="submitting"
          style="margin-top: 5px"
        >
          Sign Me Up</neo-button
        >
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  name: "NeoFormV2",
  data() {
    return {
      airtable: {
        url: "https://api.airtable.com/v0",
        token:
          "patl5n4iAJGhKe39r.b68dd19bf6401f1dda1d6dbd5880227052a335e71af0e0155db183d6bee694a1",
        base: "app4blo3nbXSr4Ytt",
        table: "tbl7Nw9UjUcMYwoEX",
      },
      form: {
        name: "",
        email: "",
        occupation: "",
        amount: null,
        location: "",
      },
      rules: {
        name: [
          { required: true, message: "Name is required", trigger: "blur" },
        ],
        email: [
          {
            type: "email",
            required: true,
            trigger: "blur",
            message: "Email is required",
          },
        ],
        occupation: [
          {
            required: true,
            message: "Please select an occupation",
            trigger: "change",
          },
        ],
        amount: [
          {
            required: true,
            message: "Please select an amount",
            trigger: "change",
          },
        ],
        location: [
          {
            required: true,
            message: "Please select a location",
            trigger: "change",
          },
        ],
      },
      occupations: [
        "Healthcare/Medical",
        "Information Technology",
        "Education/Teaching",
        "Finance/Banking",
        "Engineering",
        "Retail",
        "Customer Service",
        "Hospitality/Travel",
        "Construction",
        "Government/Public Service",
        "Student",
        "Other",
      ],
      amounts: [
        "Less than $250",
        "$250 - $500",
        "$500 - $1,000",
        "More than $1,000",
      ],
      locations: [
        "Canada - Toronto",
        "Canada - Montreal",
        "Canada - Vancouver",
        "Canada - Calgary",
        "Canada - Edmonton",
        "Canada - Other",
        "UK - London",
        "UK - Birmingham",
        "UK - Manchester",
        "UK - Glasgow",
        "UK - Leeds",
        "UK - Other",
        "US - New York City",
        "US - Los Angeles",
        "US - Chicago",
        "US - Houston",
        "US - Phoenix",
        "US - Others",
      ],
      submitting: false,
      isSuccess: false,
    };
  },

  methods: {
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitting = true;

          const payload = {
            records: [
              {
                fields: {
                  Name: this.form.email,
                  Email: this.form.email,
                  Occupation: this.form.occupation,
                  Amount: this.form.amount,
                  Location: this.form.location,
                },
              },
            ],
          };
          const { token, url, base, table } = this.airtable;
          const URL = url + "/" + base + "/" + table;

          try {
            const response = await fetch(URL, {
              method: "POST",
              mode: "cors",
              cache: "no-cache",
              credentials: "same-origin", // include, *same-origin, omit
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify(payload), // body data type must match "Content-Type" header
            });
            const data = await response.json();

            if (data.records) {
              this.isSuccess = true;
              this.$refs.form.resetFields();
              setTimeout(() => {
                this.isSuccess = false;
              }, 4000);
            }
          } catch (e) {
            console.log(e);
          } finally {
            this.submitting = false;
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.el-select {
  width: 100%;
}

.el-input__wrapper.is_focus {
  box-shadow: 0 0 0 1px #56a6c0 inset !important;
}
.el-input__wrapper:hover {
  box-shadow: 0 0 0 1px #56a6c0 inset !important;
}

#neo-form {
  .success {
    font-size: 16px !important;
    color: #00a489;
    font-weight: 600;
  }
}
</style>
